<template>
  <div class="card card-2 no-border">
    <div class="card-body">
       <b-row>
         
         <b-col cols="12" class="m-b-30">
            <h3>
              <label class="form-label" for="">Selected Store :</label>
              <span class="text-warning"> {{ storeInState.name }}</span>
            </h3>
         </b-col>
       </b-row>
       <b-row class="m-b-30">
         <b-col cols="8">
           <b-form-group
              id="fieldset-1"
              description="Give a meaningful name for the automation"
            >
              <label for="" class="custom-label">Automation title <span class="mandatory">*</span></label>
              <b-form-input size="lg" id="input-1" v-model="data.title" trim ></b-form-input>
           </b-form-group>
         </b-col>
       </b-row>
       <b-row class="m-b-30">
          <b-col cols="2">
             <b-form-group
              id="fieldset-2"
              description=""
              
            >
              <label for="" class="custom-label">Time Delay <span class="mandatory">*</span></label>
              <b-form-input class="upsell-input"  id="input-2" v-model="data.duration" trim ></b-form-input>
           </b-form-group>
          </b-col>
          <b-col cols="3">
             <b-form-group
              id="fieldset-3"
              description="Calc. in mins, hrs and days"
             
            >
            <label for="" class="custom-label">Delay Type <span class="mandatory">*</span></label>
              <b-form-select v-model="data.durationType" :options="options" ></b-form-select>
            </b-form-group>
          </b-col>
       </b-row>
       <b-row class="m-b-30">
          <b-col cols="12">
            <label for="" class="custom-label">Trigger if Products Present in Order <span class="mandatory">*</span></label>
          </b-col>
           <b-col cols="8">
              
              <div v-if="data.triggerIfProductsPresentForDisplay.length > 0">
                 <div>
                   <label for="">Selected Products</label>
                 </div>
                 <section class="selectedProducts" >
                   <div class="clearfix m-b-20 singleSelected" v-for="selectedPro in data.triggerIfProductsPresentForDisplay" :key="selectedPro.id">
                     <section class="clearfix">
                       <div class="img-thumb">
                         <img :src="selectedPro.image" alt="" class="img-fluid">
                       </div>
                       <div class="main-text">
                          <h4>{{ selectedPro.title }}</h4>
                       </div>
                       <i class="fa fa-times" aria-hidden="true" @click="removeSelected(selectedPro.id)"></i>
                     </section>
                   </div>
                 </section>
              </div>
              <b-alert variant="primary" show v-else class="height100per">
                 <div>
                   No Trigger Product selected
                 </div>
              </b-alert>
          </b-col>
          <b-col cols="4">
             <label for="">Select Products <span class="mandatory">*</span></label></label>
             <ul class="products" v-if="products.length > 0 && !inProgressProduct">
                <li  @click="addRemoveProductForTrigger(product.shopifyPkId)" v-for="product in products" :key="product.id">
                  {{ product.title }}
                </li>
              </ul>
              <div class="text-center product-wait" v-else-if="inProgressProduct" >
                <b-spinner type="grow" label="Spinning"></b-spinner>
              </div>
              <div class="syncBtnContainer">
                <b-btn variant="outline-primary" size="xs" @click="syncProductForStore(storeInState.id)">Sync Products</b-btn>
              </div>
          </b-col>
       </b-row>


       <b-row class="m-b-30">
          <b-col cols="12">
            <label for="" class="custom-label">Ignore if any 1 product present in order </label>
          </b-col>
           <b-col cols="8">
              
              <div v-if="data.ignoreIfProductsPresent.length > 0">
                 <div>
                   <label for="">Selected Products</label>
                 </div>
                 <section class="selectedProducts" >
                   <div class="clearfix m-b-20 singleSelected" v-for="selectedPro in data.ignoreIfProductsPresent" :key="selectedPro.id">
                     <section class="clearfix">
                       <div class="img-thumb">
                         <img :src="selectedPro.image" alt="" class="img-fluid">
                       </div>
                       <div class="main-text">
                          <h4>{{ selectedPro.title }}</h4>
                       </div>
                       <i class="fa fa-times" aria-hidden="true" @click="removeFromIgnoreList(selectedPro.id)"></i>
                     </section>
                   </div>
                 </section>
              </div>
              <b-alert variant="danger" show v-else class="height100per">
                 <div>
                   No Product Selected
                 </div>
              </b-alert>
          </b-col>
          <b-col cols="4">
             <label for="">Select Products </label>
             <ul class="products" v-if="products.length > 0 && !inProgressProduct">
                <li  @click="addRemoveProductForIgnore(product.shopifyPkId)" v-for="product in products" :key="product.id">
                  {{ product.title }}
                </li>
              </ul>
              <div class="text-center product-wait" v-else-if="inProgressProduct" >
                <b-spinner type="grow" label="Spinning"></b-spinner>
              </div>
              <div class="syncBtnContainer">
                <b-btn variant="outline-primary" size="xs" @click="syncProductForStore(storeInState.id)">Sync Products</b-btn>
              </div>
          </b-col>
       </b-row>

    
       <b-row class="m-b-30">
          <b-col cols="12">
            <label for="" class="custom-label">Suggest any 1 of the Product for Upsell <span class="mandatory">*</span></label>
          </b-col>
           <b-col cols="8">
              
              <div v-if="data.suggestAnyOneForUpsell.length > 0">
                 <div>
                   <label for="">Selected Products</label>
                 </div>
                 <section class="selectedProducts" >
                   <div class="clearfix m-b-20 singleSelected" v-for="selectedPro in data.suggestAnyOneForUpsell" :key="selectedPro.id">
                     <section class="clearfix">
                       <div class="img-thumb">
                         <img :src="selectedPro.image" alt="" class="img-fluid">
                       </div>
                       <div class="main-text">
                          <h4>{{ selectedPro.title }}</h4>
                       </div>
                       <i class="fa fa-times" aria-hidden="true" @click="removeSuggestion(selectedPro.id)"></i>
                     </section>
                   </div>
                 </section>
              </div>
              <b-alert variant="warning" show v-else class="height100per">
                 <div>
                   No Suggestion Product selected
                 </div>
              </b-alert>
          </b-col>
          <b-col cols="4">
             <label for="">Select Products <span class="mandatory">*</span></label>
             <ul class="products" v-if="products.length > 0 && !inProgressProduct">
                <li  @click="addRemoveProductForSuggestion(product.shopifyPkId)" v-for="product in products" :key="product.id">
                  {{ product.title }}
                </li>
              </ul>
              <div class="text-center product-wait" v-else-if="inProgressProduct">
                <b-spinner type="grow" label="Spinning"></b-spinner>
              </div>
              <div  class="syncBtnContainer">
                <b-btn variant="outline-primary" size="xs" @click="syncProductForStore(storeInState.id)">Sync Products</b-btn>
              </div>
          </b-col>
       </b-row>
       <b-row class="m-b-30">
         <b-col cols="12">
            <b-form-checkbox v-model="data.ignoreIfProductsPurchased" name="check-button" switch>
              Ignore if products purchased in last order 
            </b-form-checkbox>
         </b-col>
       </b-row>
       <section class="phone-section">
         
         <div class="phone">
             
              <img src="~@/assets/images/phone-in-hand.png" alt="" class="img-fluid">
              <div class="led">
                <div class="messageOnMobile" v-html="mobileSms">
                  
                </div>
              </div>
         </div>
         <div class="actualMessage">
            <label for="" class="custom-label">Create SMS Message <span class="mandatory">*</span></label>
            <b-form-textarea v-model="sms" rows="12" class="actualMsgInput"></b-form-textarea>
            <div class="m-t-30 text-success">
              You can use dynamic values of {customer_name},{store_name}, {order_number} and {suggestion_link}

             
            </div>
         </div>
       </section>
       <b-row class="m-b-30">
          <b-col cols="6">
            <b-form-group label="Is the Upsell Trigger Active ?">
              <b-form-radio-group
                v-model="data.activeInactiveSelected"
                :options="activeInactive"
                name="radio-inline"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          
       </b-row>
       <b-row class="m-b-30">
         <b-col cols="6">
            <b-form-checkbox v-model="data.dryRun" name="check-button" switch>
              Dry Run mode. Actual notification will not be sent.
            </b-form-checkbox>
         </b-col>
       </b-row>
       <b-row>
         <b-col cols="6" offset="6">
           <b-btn variant="primary" block size="lg" @click="addUpdateUpsellAutomation" :disabled="disableForm">
              <div v-if="inProgress">
                <b-spinner small type="grow"></b-spinner>
                Please Wait. Processing...
              </div>
              <div v-else>
                {{ itsAnUpdateRecord ? 'Update' : 'Add' }} Upsell Automation
              </div>
           </b-btn>
           
           
         </b-col>
       </b-row>
    </div>
  </div>
</template>

<script>
import ProductsService from '../../../services/products.service';
const ActualUpsellMessage = () => import(/* webpackChunkName: "actual-upsell-message" */ "./actual-upsell-message")
import UpsellAutomationService from '../../../services/upsell-automation.service';
import StoreService from '../../../services/store.service';


  export default {
     components: {ActualUpsellMessage},
     data(){
       return {
          mockData: {
            customer_name: 'Peter', 
            store_name: this.storeInState ? this.storeInState.name : 'ABC Stores',
            order_number: 'ABC123',
            suggestion_link: 'https://store.com/product-link'
          },
          products: [],
          data: {
            title: '',
            duration: null,
            durationType: null,
            triggerIfProductsPresentForDisplay: [],
            suggestAnyOneForUpsell: [],
            ignoreIfProductsPurchased: true,
            randomlySuggested: null,
            dryRun: true,
            activeInactiveSelected: 'active',
            randomlySuggestedProductId: null,
            ignoreIfProductsPresent: []
          },
          sms: '{store_name}: Hello, {customer_name}. Thanks for purchasing. As a huge thank you for your support we like to offer you a limited time 20% OFF from . Get it here: {suggestion_link}',
          mobileSms: '',
          options: [
              { value: null, text: 'Select' },
              { value: 'minutes', text: 'minutes' },
              { value: 'hours', text: 'hours' },
              { value: 'days', text: 'days' },
            ],
          activeInactive: [
              { text: 'Active', value: 'active' },
              { text: 'Inactive', value: 'inactive' },
            ],
          storeRecord:{},
          triggerData: {},
          inProgress: false,
          inProgressProduct: false
       }
     },
     watch:{
       sms(newValue, oldValue){
          console.log('Update mobile sms')
          this.mobileSms = this.formDisplaySMS(this.sms, this.mockData);
       },
     },
     mounted(){
       // If no store was selected, go back to upsell list page
       if(!this.storeInState.id){
          this.$router.push('upsell')
       } 
       else{
          this.fetchStoreProducts()
          this.mockData.store_name =  this.storeInState ? this.storeInState.name : 'ABC Stores',
          this.mobileSms = this.formDisplaySMS(this.sms, this.mockData);
          this.fetchStoreRecord(this.storeInState.id)

          
       }

       
       
     },
     methods: {
       async fetchStoreProducts(){
          try{
            this.inProgressProduct = true;
            const result = await ProductsService.fetchProducts(this.storeInState.id);
            this.products = result.data.products;

            this.inProgressProduct = false;
            // If id was there in the route, fetch the data for the trigger.
            if(this.$route.params.id){
                  this.fetchTriggerDataById(this.$route.params.id)
            }

          }catch(e){
            this.inProgressProduct = false;
            console.log("It's error", e)
          }
       },
       addRemoveProductForTrigger(shopifyPkId){
          let particularProduct = this.products.find(product => product.shopifyPkId == shopifyPkId);
          if(particularProduct){

             let alreadyExists = this.data.triggerIfProductsPresentForDisplay.find(product => product.shopifyPkId == shopifyPkId);
             if(!alreadyExists){
               this.data.triggerIfProductsPresentForDisplay.push(particularProduct)
             }
             
          }
       },
       addRemoveProductForIgnore(shopifyPkId){
        let particularProduct = this.products.find(product => product.shopifyPkId == shopifyPkId);
            if(particularProduct){

                let alreadyExists = this.data.ignoreIfProductsPresent.find(product => product.shopifyPkId == shopifyPkId);
                if(!alreadyExists){
                  this.data.ignoreIfProductsPresent.push(particularProduct)
                }
                
              }
       },
       addRemoveProductForSuggestion(shopifyPkId){
          let particularProduct = this.products.find(product => product.shopifyPkId == shopifyPkId);
          if(particularProduct){

             let alreadyExists = this.data.suggestAnyOneForUpsell.find(product => product.shopifyPkId == shopifyPkId);
             if(!alreadyExists){
               this.data.suggestAnyOneForUpsell.push(particularProduct)
             }

             // randomize suggested
             this.randomizeSuggested()


             
          }
       },
       removeSelected(productId){
          this.data.triggerIfProductsPresentForDisplay = this.data.triggerIfProductsPresentForDisplay.filter(product => product.id != productId)
       },
       removeFromIgnoreList(productId){
          this.data.ignoreIfProductsPresent = this.data.ignoreIfProductsPresent.filter(product => product.id != productId)
       },
       removeSuggestion(productId){
         this.data.suggestAnyOneForUpsell = this.data.suggestAnyOneForUpsell.filter(product => product.id != productId)
         this.randomizeSuggested()
       },
       formDisplaySMS(s, obj){
        return s.replace(/{([^}]+)}/g, function (_, path) {
          const properties = path.split(".");
          return properties.reduce((prev, curr) => prev && '<span class="dynamic-values">' + prev[curr] + '</span>', obj);
        });
      },
      async addUpdateUpsellAutomation(){
          
          // Refine the data before sending.

           let data = {
            title: this.data.title,
            delayDuration: this.data.duration,
            delayDurationType: this.data.durationType,
            triggerIfProductsPresent: this.data.triggerIfProductsPresentForDisplay.map(product => product.shopifyPkId),
            ignoreIfProductsPresent: this.data.ignoreIfProductsPresent ? this.data.ignoreIfProductsPresent.map(product => product.shopifyPkId) : [],
            suggestAnyOneForUpsell: this.data.suggestAnyOneForUpsell.map(product => product.shopifyPkId),
            ignoreIfProductsPurchased: this.data.ignoreIfProductsPurchased ? 'yes' : 'no',
            randomlySuggested: this.data.randomlySuggested ? this.data.randomlySuggested : null,
            dryRun: this.data.dryRun ? 'yes' : 'no',
            shopifyStoreId: this.storeInState.id,
            messageBody: this.sms,
            activeStatus: this.data.activeInactiveSelected,
            randomlySuggestedProductId: this.data.randomlySuggestedProductId
          };

          if(this.$route.params.id){
            data.id = this.$route.params.id
          }

          try{
            this.inProgress = true;
            const result = await UpsellAutomationService.createUpdateTrigger(data);
            console.log(result.data.message)
            this.$router.push({name: 'upsell'})
            this.inProgress = false;
          }catch(e){
            console.log(e)
            this.inProgress = false;
          }
      },
      async fetchStoreRecord(storeId){
        try{
           const storeResult = await StoreService.fetchParticularStore(storeId)
           this.storeRecord = storeResult.data.store;
        }catch(e){
          console.log(e)
        }
      },
      randomizeSuggested(){
        // Get a randomly suggested
        if(this.data.suggestAnyOneForUpsell.length > 0){

           let randomProduct = this.data.suggestAnyOneForUpsell[Math.floor(Math.random() * this.data.suggestAnyOneForUpsell.length)];

           this.data.randomlySuggested = `${this.storeRecord.siteUrl}collections/all/products/${randomProduct['handle']}`;

           this.data.randomlySuggestedProductId = randomProduct['shopifyPkId'];
           
        }
        else{
          this.data.randomlySuggested = 'https://store.com/product-link'
        }
        this.mockData.suggestion_link = this.data.randomlySuggested
        this.mobileSms = this.formDisplaySMS(this.sms, this.mockData);
      },
      async fetchTriggerDataById(id){
         try{
            const result = await UpsellAutomationService.fetchTriggerById(id)
            this.triggerData = result.data.trigger;
            this.data.title = this.triggerData.title;
            this.data.duration = this.triggerData.delayDuration;
            this.data.durationType = this.triggerData.delayDurationType;
            this.data.triggerIfProductsPresentForDisplay = this.products.filter(product => {
               return  this.triggerData.triggerIfProductsPresent.includes(product.shopifyPkId);
            })
            this.data.suggestAnyOneForUpsell = this.products.filter(product => {
               return  this.triggerData.suggestAnyOneForUpsell.includes(product.shopifyPkId);
            })
            this.data.randomlySuggested = this.triggerData.randomlySuggested;
            this.data.randomlySuggestedProductId = this.triggerData.randomlySuggestedProductId;
            this.data.ignoreIfProductsPresent = this.products.filter(product => {
               return  this.triggerData.ignoreIfProductsPresent.includes(product.shopifyPkId);
            })

            

            // 
            this.mockData.suggestion_link = this.triggerData.randomlySuggested;
            
            this.sms = this.triggerData.messageBody
            this.mobileSms = this.formDisplaySMS(this.sms, this.mockData);
            this.data.ignoreIfProductsPurchased = this.triggerData.ignoreIfProductsPurchased == 'yes' ? true : false;
            
            this.data.dryRun = this.triggerData.dryRun == 'yes' ? true : false;
            this.data.activeInactiveSelected =  this.triggerData.activeStatus;
         }catch(e){
           console.log(e)
         }
      },
      async syncProductForStore(storeId){
         try{
           this.inProgressProduct = true;
           const result = await ProductsService.syncProducts(storeId);
           setTimeout(() => {
             this.fetchStoreProducts();
           }, 5000)
           
         }catch(e){
            console.log(e.response.data)
         }
      }
     },
      computed: {
        storeInState() {
          return this.$store.state.ecommerceStore.store
        },
        itsAnUpdateRecord(){
           if(this.$route.params.id){
             return true
           }
           return false;
        },
        disableForm(){
           let disabled = null;
          
          if(!this.data.title || !this.data.duration || !this.data.durationType || this.data.triggerIfProductsPresentForDisplay.length == 0 || this.data.suggestAnyOneForUpsell.length == 0 || !this.sms){
             disabled = true;
          }else{
            disabled = false;
          }
          return disabled;
        }
    },
  }
</script>

<style lang="scss" scoped>
  .upsell-input{
    height: 38px;
    border-radius: 5px;
  }
  .height100per{
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
 
  .products{
     padding-left: 0;
     list-style-type: none;
     overflow-x: hidden;
     overflow-y: auto;
     height: 240px;
     margin-bottom: 30px;
     li{
       cursor: pointer;
       padding: 15px;
       border-bottom: 1px dashed rgb(209, 209, 209);
       font-size: 13px;
       transition: all 300ms ease;
     }
     li:hover{
       background-color: rgb(11, 109, 255);
       color: #fff;
     }
     li:first-child{
        border-top: 1px dashed rgb(209, 209, 209);
     }
     
  }
  
  .img-thumb{
    width: 80px;
    height: 80px;
    float: left;
    overflow: hidden;
    position: relative;
    img{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%)
    }
  }
  .selectedProducts{
    display: flex;
    flex-wrap: wrap;
    .singleSelected{
      width: 50%;
      padding: 0 5px;
      section{
        border: 1px solid rgb(207, 207, 207);
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        i{
          position: absolute;
          right: 5px;
          top: 50%;
          transform: translate(0, -50%);
          cursor: pointer;
          color: red;
        }
        .main-text{
          margin-left: 90px;
          margin-right: 10px;
          margin-top: 10px;
        }
        .main-text h4{
          font-size: 13px;
        }
      }
    }
  }
  .phone-section{
     display: flex;
     margin-bottom: 60px;

     .phone{
       width: 400px;
       position: relative;
       img{
         position: relative;
         z-index: 2;
         width: 100%;
         height: auto;
       }
       .led{
          width: 228px;
          height: 450px;
          overflow-x: hidden;
          overflow-y: auto;
          background-color: rgb(255, 255, 255);
          padding: 25px 15px;
          position: absolute;
          left: 52px;
          top: 17px;
          z-index: 1;

       }
       .messageOnMobile{
          padding: 10px;
          border-radius: 5px;
          background-color:  rgb(224, 226, 233);
          color: rgb(28, 31, 44);
          font-size: 13px;
          width: 100%;
          box-shadow: 1px 1px 5px rgba(0,0,0,0.1)
       }
     }
  }

  .custom-label{
    font-weight: 500;
  }
  .actualMessage{
    flex: 1;
    padding-left: 30px;
  }
  strong{
    background-color: red;
  }
  .actualMsgInput{
    font-size: 14px;
    line-height: 22px;
    border-radius: 3px;
  }
  .mandatory{
    color: rgb(238, 58, 58);
    font-size: 30px;
    position: relative;
    top: 10px;
  }
  .product-wait{
    padding: 20px 0;
  }
</style>